import { SVGIconComponent } from './types';

export const LockerXS: SVGIconComponent = ({ className, color, style }) => (
  <svg
    version="1.0"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 25 20"
    xmlSpace="preserve"
    style={{ color, ...style }}
    className={className}
  >
    <g id="Locker-Sizes_x2F_locker-XS">
      <g id="locker-S" transform="translate(6.000000, 3.000000)">
        <g id="S">
          <path
            id="path-1_00000163772500581947258480000004375091393719609015_"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="currentColor"
            d="M13,0l5.3,2.5c0.2,0.1,0.3,0.3,0.3,0.5
				l0,4.8c0,0.2-0.1,0.3-0.2,0.4L6.8,16.6l0,0c0,0,0,0,0,0l0,0c0,0-0.1,0-0.1,0.1c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0
				c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0
				l-6-2.9C0.1,13.7,0,13.5,0,13.3V8.9c0-0.3,0.2-0.5,0.4-0.5l2.5-1.7L3.1,7l1.1,0L1.5,8.9L6.4,11l10.7-7.8l-4.3-2.1l-1.9,1.3
				c0.1-0.4,0-0.8-0.1-1.2l1.7-1.2C12.7,0,12.8,0,13,0z M1,9.8V13l5,2.3v-3.4L1,9.8z M17.6,4.2L7,11.8v3.4l10.6-7.6V4.2z"
          />
        </g>
      </g>
      <path
        id="XS"
        fill="currentColor"
        d="M7,9l1.3-2.1h0L9.7,9h1.2L9,6.2v0l1.9-2.8H9.8L8.4,5.5h0L7.1,3.4H5.9l1.8,2.8v0L5.9,9H7z M13.8,9.1
		c1.4,0,2.2-0.7,2.2-1.8v0c0-0.9-0.5-1.3-1.7-1.6l-0.6-0.1c-0.7-0.1-1-0.4-1-0.8v0c0-0.5,0.4-0.8,1.1-0.8c0.6,0,1.1,0.3,1.1,0.7l0,0
		h1l0-0.1c-0.1-0.9-0.8-1.6-2.1-1.6c-1.2,0-2.1,0.7-2.1,1.7v0c0,0.8,0.5,1.4,1.7,1.6L14,6.7c0.7,0.2,1,0.4,1,0.8v0
		c0,0.5-0.5,0.8-1.2,0.8c-0.7,0-1.2-0.3-1.3-0.8l0,0h-1l0,0.1C11.7,8.5,12.5,9.1,13.8,9.1z"
      />
    </g>
  </svg>
);
